<template>
  <div>
    <vx-card>
      <vs-table
        :max-items="descriptionItems[0]"
        class="mt-3"
        pagination
        :data="disbursements"
        description
        :description-items="descriptionItems"
        description-title="Registries"
        description-connector="of"
        description-body="Pages"
      >
        <template slot="header">
          <!-- ADD NEW -->
        </template>
        <template slot="thead">
          <vs-th>{{ $t("entity.label.id") }}</vs-th>
          <vs-th>{{ $t("entity.label.transaction_date") }}</vs-th>
          <vs-th>{{ $t("entity.label.source") }}</vs-th>
          <vs-th>{{ $t("entity.label.commission_amount") }}</vs-th>
          <vs-th>{{ $t("entity.label.commission_type") }}</vs-th>
          <vs-th>{{ $t("entity.label.commission_rate") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.id">{{ tr.id }}</vs-td>
            <vs-td :data="tr.transactionDate">{{ tr.transactionDate }}</vs-td>
            <vs-td :data="tr.source">{{ tr.source }}</vs-td>
            <vs-td :data="tr.commissionamount">{{ tr.commissionamount }}</vs-td>
            <vs-td :data="tr.commissiontype">{{ tr.commissiontype }}</vs-td>
            <vs-td :data="tr.commissionrate">{{ tr.commissionrate }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>
export default {
  props: ["entityName"],
  data() {
    return {
      descriptionItems: [5, 10, 15],
    };
  },
  computed: {
    disbursements() {
      return this.$store.getters["entity/getDisbursements"];
    },
  },
  methods: {
    async displayDisbursements() {
      try {
        this.$store.dispatch("entity/setDisbursements", this.entityName);
      } catch (e) {
        this.$toasted.error("something went wrong!");
      }
    },
  },
  mounted() {
    this.displayDisbursements();
  },
};
</script>
<style lang="scss" scoped>
</style>